import { CommonModule } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { AngularMaterialsModules } from '../../../module/materials.module'
import { AgentCourse, CourseSession } from '../models/agent.models'

interface CalendarDay {
  date: Date
  dayNumber: number
  isCurrentMonth: boolean
  isToday: boolean
  session?: CourseSession
}

@Component({
  selector: 'ddc-agent-course',
  templateUrl: './ddc-agent-course.component.html',
  styleUrls: ['./ddc-agent-course.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcAgentCourseComponent implements OnChanges {
  @Input() course!: AgentCourse
  @Input() theme: string = 'light-theme'

  calendarDays: CalendarDay[] = []
  weekDays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
  currentMonth: Date = new Date()

  ngOnChanges(): void {
    this.buildCalendar()
  }

  prevMonth(): void {
    this.currentMonth = new Date(
      this.currentMonth.getFullYear(),
      this.currentMonth.getMonth() - 1,
      1,
    )
    this.buildCalendar()
  }

  nextMonth(): void {
    this.currentMonth = new Date(
      this.currentMonth.getFullYear(),
      this.currentMonth.getMonth() + 1,
      1,
    )
    this.buildCalendar()
  }

  get daysUntilNextSession(): number | null {
    if (!this.course?.nextSession) return null
    const next = new Date(this.course.nextSession.date)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    next.setHours(0, 0, 0, 0)
    return Math.round((next.getTime() - today.getTime()) / 86400000)
  }

  private buildCalendar(): void {
    const year = this.currentMonth.getFullYear()
    const month = this.currentMonth.getMonth()
    const firstDay = new Date(year, month, 1)
    // Monday-first offset
    const startOffset = (firstDay.getDay() + 6) % 7
    const start = new Date(year, month, 1 - startOffset)

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const sessionMap = new Map<string, CourseSession>()
    for (const s of this.course?.sessions ?? []) {
      sessionMap.set(new Date(s.date).toDateString(), s)
    }

    this.calendarDays = []
    for (let i = 0; i < 42; i++) {
      const date = new Date(start)
      date.setDate(start.getDate() + i)
      this.calendarDays.push({
        date,
        dayNumber: date.getDate(),
        isCurrentMonth: date.getMonth() === month,
        isToday: date.toDateString() === today.toDateString(),
        session: sessionMap.get(date.toDateString()),
      })
    }
  }
}
